import { useModalStore } from "@/hooks/Modal/hooks";
import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import { Menu } from "antd";
import DropdownButton from "@/components/DropdownButton";
import { observer } from "mobx-react-lite";
import React from "react";
import SupplierIncrementSyncOrderModal from "./SupplierIncrementSyncOrderModal";
import SupplierSyncOrderByOriginalIdsModal from "./SupplierSyncOrderByOriginalIdsModal";
import { MenuDivider, MenuItem, MenuItemGroup, SubMenu, buildMenuItems } from "@/utils/antdItems";

interface SupplierSyncDropButtonProps {
    supplierShopId: number;

    tab: OrderTab;
}

const SupplierSyncDropButton: React.FC<SupplierSyncDropButtonProps> = function (props) {
    const { supplierShopId, tab } = props;

    const { openModal } = useModalStore();

    function handleSyncOrderMenuClick({ key }) {
        if (key === "syncOrderByOriginalIdButton") {
            openModal(SupplierSyncOrderByOriginalIdsModal, { supplierShopId, tab });
        }
    }

    function handleSyncOrderButtonClick() {
        openModal(SupplierIncrementSyncOrderModal, { supplierShopId, tab });
    }

    return (
        <DropdownButton menu={{ items: [] }}
            onClick={handleSyncOrderButtonClick}
            trigger={["click"]}
            placement="bottomLeft"
            popupRender={() => <Menu onClick={handleSyncOrderMenuClick} items={buildMenuItems(<>
                    <MenuItem key="syncOrderByOriginalIdButton">
                        <span>按订单编号同步订单</span>
                    </MenuItem>
                </>)} />}
            className="ant-btn-group-success"
        >
            同步代理商订单
        </DropdownButton>
    );
};

export default observer(SupplierSyncDropButton);
